const options: string[] = [
  '#EC313D',
  '#EC8031',
  '#ECC331',
  '#35EC31',
  '#31EC9E',
  '#31A9EC',
  '#3144EC',
  '#A531EC',
  '#EC31D9',
  '#EC3174',
  '#11824C',
  '#0B0964',
  '#69082B',
  '#776B6F',
  '#C0B5B9',
  '#211F54',
];

const colorDefault = '#211F54';

export const folderColor = { default: colorDefault, options };
